import api from './api'

const loadChargerUsage = (userId: string): Promise<Array<{ chargePointName: string; percentage: number }>> =>
    api<Array<{ chargePointName: string; percentage: number }>>({ path: `/stats/users/${userId}/chargerusage` })

export default loadChargerUsage
